var React = require('react');

function ContentExpand (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"none","strokeWidth":"1","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"},React.createElement("g",{"transform":"translate(-110.000000, -1050.000000)","strokeWidth":"2"},React.createElement("g",{"transform":"translate(90.000000, 949.000000)"},React.createElement("g",{"transform":"translate(7.000000, 84.000000)"},React.createElement("polyline",{"points":"30 18 22 26.5333333 14 18"}))))));
}

ContentExpand.defaultProps = {"role":"presentation","viewBox":"0 0 18 11","version":"1.1"};

module.exports = ContentExpand;

ContentExpand.default = ContentExpand;
